<template>
    <div>
      <!--弹出框-->
      <el-form label-width="100px" class="demo-ruleForm" style="height: 100%">
        <el-dialog title="知识库文件导入" v-dialogDrag :visible.sync="knowledgebasepopupDialog" :close-on-click-modal="false" :show-close="true" :close-on-press-escape="false" :before-close="handleClose"
         :show-file-list="false">
         <el-divider direction="vertical" style="width: 2px;height: 100%;" v-if="isVisible"></el-divider>
          <el-row class="rowTop" style="margin-top: 15px;">
            <el-col :span="24">
              <div class="titna">
                <span class="addSpan">文件</span>
              </div>
              <div class='fujian' style="height: 500px"  v-loading="loading"  element-loading-text="文件正在上传中，请稍后..." >
                <el-upload class="upload-demo" drag multiple action="" 
                  :file-list="fileList" :auto-upload='false' :on-change="changes" ref="upload">
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">可将多文件拖到此处，或<em>点击上传</em></div>
                  <div class="el-upload__tip" style="color: #b3b3b3" slot="tip">
                    注：能上传.doc/.docx,.jpg/.png,.xls/.xlsx,.pdf文件，且不超过50M
                  </div>
                  <template #file="{ file }">
                        <div class="file-item">
                        <span>{{ file.name }}</span>
                        <el-button type="text" @click="handleRemove(file)">删除</el-button>
                        </div>
                  </template>
                </el-upload>
              </div>
            </el-col>
            <!-- <div style="flex:1" v-loading="loading"  element-loading-text="文件正在上传中，请稍后..." v-if="isVisible"></div> -->
          </el-row>
      
          <span slot="footer" class="dialog-footer">
            <el-form-item>
              <el-button round @click="empty()" type="warning">取 消</el-button>
              <el-button round type="primary" @click="save()">保 存</el-button>
            </el-form-item>
          </span>
        </el-dialog>
      </el-form>
    </div>
  </template>

<script>
import axios from "axios";
import { Progress } from 'element-ui';
export default {
  props: {
    
  },
  computed: {  
    isVisible() {  
      return this.isHiddenUploadDiv;  
    }  
  },
  data() {
    return {
        filetabledata: [],
        fileList: [],
        knowledgebasepopupDialog: true,
        urlsss:'/userApi/minio/updateFileMulti',
        finishedFileList: [],
        'el-progress': Progress,
        loadingVisible: false,//开启遮罩
        loading: false
    };
  },
  created() {
    //初始化数据
  },
  components: {
    
  },
  methods: {
    handleRemove(file) {
            const index = this.fileList.indexOf(file);
            if (index !== -1) {
            this.fileList.splice(index, 1);
            }
        },
    empty(){
        this.$emit("knowledgeDialogCancel");
    },
    handleClose(){
        this.$emit("knowledgeDialogCancel");
    },
    checkFileType(filename) {
      const pattern = /\.(jpg|png|pdf|doc|docx|xls|xlsx)$/i;
      return pattern.test(filename.toLowerCase());
    },
    
    changes(file, fileList) {
      let num = 1024.00;
      if (!file) {
        // 没有文件
        return false;
      }  else if (Number((file.size / Math.pow(num, 2)).toFixed(2)) > 50) {// 检查文件大小
        fileList.splice(fileList.length - 1, 1);
        this.$message.error('选择文件大于50M，请重新选择！');
      }else if (!this.checkFileType(file.name)) {// 检查文件类型
        // 格式根据自己需求定义
        this.$refs.upload.clearFiles();
        this.$message.error("上传格式不正确，请上传xls或者xlsx格式");
        return false;
      }else {
        this.fileList.push(file.raw);
      }
    },
    save(){
      this.loading = true;
      let _this = this;
      if (this.fileList.length !== 0) {       
        const uploads = this.fileList.map(file => this.uploadFile(file));
        Promise.all(uploads).then((res)=>{
          const inserFiles = _this.finishedFileList.map(file => this.insertFile(file)); 
          Promise.all(inserFiles).then((res)=>{
            console.log("所有请求都完成后，执行这里的代码", res);
            _this.$message({
                  message: '所有文件上传成功！',
                  type: 'success'
                });
                _this.loading = false;
                _this.fileList = [];
                _this.$emit('knowledgeDialogCancel');
                let params = {
                  pageSize: 20,
                  pageNum: 1,
                  fileName: '',
                  userId: '',
                };
                _this.$parent.getList(params);


          }).catch(err => {
        // 处理上传请求的错误
        console.error(err);
        // this.$notify({
        //   title: "提示",
        //   message: "文件夹上传失败",
        //   type: "error"
        // });
      });;
                   
        }).catch(err => {
        // 处理上传请求的错误
        console.error(err);
        // this.$notify({
        //   title: "提示",
        //   message: "文件夹上传失败",
        //   type: "error"
        // });
      });       
      } else {
        
      }
      //另一种上传方法
      // this.loading = true;      
      // // 上传发出的请求列表
      // let fileRequests = []; 
      // let config = {
      //   headers: {
      //     "Content-Type": "multipart/form-data",
      //     "Access-Token": this.$store.state.token // 请替换为实际的Access-Token值
      //   }
      // };
      // //循环文件列表上传
      // this.fileList.forEach(file => {         
      //     //定义FormData格式的参数
      //     let formData = new FormData();
      //     // formData.append('folder', 'album'); //假设上传到服务器上指定的album文件夹下
      //     formData.append('file', file);

      //     //axios接收到FormData格式的参数，自动使用Content-Type: multipart/form-data方式上传
      //     let fileRequest = axios.post(this.urlsss, formData, config)
      //         .then(function (response) {
      //             return response.data;
      //         })
      //         .catch(function (error) {
      //             return error
      //         });             
      //     //把上传请求加入列表
      //     fileRequests.push(fileRequest); 
      // });

      // //所有请求完成结果
      // Promise.all(fileRequests).then((response) => {
      //     //所有请求都完成后，执行这里的代码
      //     console.log("所有请求都完成后，执行这里的代码", response);
      //     this.$message({
      //           message: '文件夹上传成功！',
      //           type: 'success'
      //         });
      //     this.loading = false;
      //     this.$emit('folderimportcancel')
      // }).catch((error) => {
      //     console.log(error);
      // })
    },
    //上传文件到minio
    uploadFile(file) {
      return new Promise((resolve, reject) => {
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Token": this.$store.state.token // 请替换为实际的Access-Token值
        }
      };
      const formData = new FormData();
      formData.append('file', file);
      
      axios.post('/userApi/minio/updateFileMulti', formData, config).then(res => {
        this.finishedFileList.push(res.data.data[0]);
        resolve(res.data)
      }).catch(err => {
        this.failedFileList.push(file);
        reject(err)
      });
    });
    },
    //文件提交
    insertFile(file) {
      return new Promise((resolve, reject) => {
        let saveConfig = {
                headers: {
                  "Content-Type": "application/json",
                  "Access-Token": this.$store.state.token // 请替换为实际的Access-Token值
                },
              };
      let uploadedFile = {
                fileSourceName: file.fileName,
                fileType: file.fileType,
                fileName: file.sourceName,
              };
      
      axios.post('/userApi/ydb/knowledgebase/insert', uploadedFile, saveConfig).then(res => {
        resolve(res.data)
      }).catch(err => {
        this.failedFileList.push(file);
        reject(err)
      });
    });
    },
  },
  mounted() {
    
  }
};
</script>

<style scoped="scoped">
.el-dialog {
  width: 1000px;
}

.el-dialog__body {
  height: 450px;
  overflow: auto;
}

.fujian {
  width: calc(100% - 112px);
  width: -webkit-calc(100% - 112px);
  width: -moz-calc(100% - 112px);
  float: right;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 10px;
  overflow: auto;
}

.addSpan {
  line-height: 30px;
  margin-right: 10px;
}

.el-divider--vertical{
  height: 100%;
}
</style>
